<template>
  <div class="home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>
    <div class="mission-content ac crfff">
      <div class="fs50 mt50">{{ $t('aiDressUp') }}</div>
      <div class="css-1asaykn mt50">
        <!--          <div class="css-1asaykn mt20">-->
        <!--            <img width="100%" src="../../static/images/aiDressUp.jpg" />-->
        <!--          </div>-->
        <div class="css-12nj5ib mt30">
          <div style="">{{ $t('aiDressUp_tip') }}</div>
        </div>
        <div id="controlBox" class="oneImageInput mt50">
          <div class="oneImageInput-content">
            <input accept="image/*" class="file" mutiple="mutiple" type="file" @change="convertToBase64_v2">
            <div class="imageInputBox">
              <div class="uploadBox uploadIcon">
                <img v-if="imageBase64" :src="imageBase64" style="width:80%;"/>
                <div v-else class="">
                  <img src="../../static/images/transparent.png" width="80">
                  <div class="label"> {{ $t('Upload') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isSex" class="ul hair-ul">
          <div v-for="(item,index) in sexList" :class="{'active':isType==item.key}" class="li" @click="getClick(item)">
            <img v-if="isType==item.key" class="dui" src="../../static/images/dui.png">
            <img :src="'../../static/images/dress_up_'+(index+1)+'.png'" class="img"/>
            <div class="name">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ac mt30">
      <button class="button" style="width: calc(100% - 100px);" @click="uploadImage">
        <strong>{{ $t('Generate') }}</strong></button>
    </div>
    <div class="flex mt50" style="justify-content: space-around;width: 94%;margin: 0 auto;">
      <button class="btn btn-blue">{{$t('ChancesLeft')}} : {{score}}</button>
<!--      <button class="button fs12 ml10" @click="goPurchaseChances"><strong>{{$t('BuyChances')}}</strong><img style="margin-left: 0.1rem;" width="15" src="../../static/images/buy.png"></button>-->
    </div>
    <Dialog ref="imgDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert"
            width="100">
      <div slot="mdBox" class="alert-modal">
        <div class="close" style="text-align: right;margin: 0 auto;font-size: 50px;" @click="closeTmgDialog">×</div>
        <div v-if="imageShow" class="image ac">
          <div class="" style="font-size:0.3rem;margin-bottom: 20px;">{{ $t('downTips1') }}</div>
          <img v-if="isShowResult==1" :src="detail.url" style="width:80%;"/>
          <img v-if="isShowResult==2" :src="detail.original_url" style="width:80%;"/>

          <div class="tab mt50">
            <span :class="{'active':isShowResult==1}" @click="getResult(1)">{{ $t('Result') }}</span>
            <span :class="{'active':isShowResult==2}" @click="getResult(2)">{{ $t('Original') }}</span>
          </div>
          <div class="img-tools">
            <div class="ac disflex mt30">
              <div class="input-item">
                <div v-if="isShowResult==1" class="input-item2">
                  <input v-model="detail.url" class="input" disabled placeholder="" type="">
                  <img v-if="detail.url" id="copycode" :data-clipboard-text="detail.url"
                       src="../../static/images/Copy.png" style="margin-left: 10px;width: 1rem" @click="copy"/>
                </div>
                <div v-if="isShowResult==2" class="input-item2">
                  <input v-model="detail.original_url" class="input" disabled placeholder="" type="">
                  <img v-if="detail.original_url" id="copycode" :data-clipboard-text="detail.original_url"
                       src="../../static/images/Copy.png" style="margin-left: 10px;width: 1rem" @click="copy"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>


    <Dialog ref="processDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert"
            width="100">
      <div slot="mdBox" class="alert-modal ac">
        <div class="fs33 mt50 ac">{{ processMsg }}</div>
        <button class="button mt30" @click="closeProcessDialog">{{ $t('OK') }}</button>
      </div>
    </Dialog>

  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header, Dialog
  },
  data() {

    return {
      detail: {},
      isShow: false,
      value: 50,
      imageShow: false,
      imageBase64: null,
      imageTpye: '',
      withScratch: false,
      isImgModel: false,
      isImage: true,
      score: 0,
      isShowResult: 1,
      processMsg: "",
      isType: '',
      isSex: true,
      sexList: [
        {'title': 'Style1', 'key': '474495'},
        {'title': 'Style2', 'key': '477305'},
        {'title': 'Style3', 'key': '477306'},
        {'title': 'Style4', 'key': '477307'},
        {'title': 'Style5', 'key': '477312'},
        {'title': 'Style6', 'key': '477308'},
        {'title': 'Style7', 'key': '477309'},
        {'title': 'Style8', 'key': '477310'},
        {'title': 'Style9', 'key': '477311'},
        {'title': 'Style10', 'key': '477313'},
      ],
    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    this.getHome();
  },
  methods: {
    getClick(item) {
      this.isType = item.key
    },
    getResult(type) {
      this.isShowResult = type
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        });
      })
    },
    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
          // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    convertToBase64_v2(event) {
      let that = this;
      const file = event.target.files[0];
      if (!file) return;
      // 原始大小（单位：KB）
      const originSizeKB = (file.size / 1024).toFixed(2);
      console.log("原始文件大小:", originSizeKB, "KB");
      // 1. 文件大小限制（5MB）
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        that.$refs.processDialog.showMaskFun();
        that.processMsg = this.$t('pic_size_limit')
        event.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          // 2. 缩放尺寸
          const maxWidth = 800;
          const maxHeight = 800;
          let {width, height} = img;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          // 3. PNG 自动转 JPEG
          let outputType = file.type.toLowerCase() === 'image/png' ? 'image/jpeg' : file.type;
          // 4. 压缩导出（JPEG 质量 0.7）
          this.imageBase64 = canvas.toDataURL(outputType, 0.7);
          // 5. 设置上传类型
          this.imageTpye = outputType.split('/')[1]; // e.g. "jpeg"
          // 计算压缩后的大小
          const compressedSize = this.base64Size(this.imageBase64);
          console.log("压缩后文件大小:", (compressedSize / 1024).toFixed(2), "KB");
        };
      };

      reader.readAsDataURL(file);
      event.target.value = '';
    },
    uploadImage() {
      let that = this
      if (!that.isType) {
        that.$utils.alertText(that.$t('sexTitle2'), 100);
        return;
      } else if (!that.imageBase64) {
        that.$utils.alertText(that.$t('uploadTips'), 100);
        return;
      }
      let data = {
        image: {
          type: that.imageTpye,
          content: that.imageBase64
        },
        style: that.isType
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/ai_dress_up', data, r => {
        that.$parent.loadModal(false);
        that.getHome()
        if (r.code == 0) {
          that.$refs.processDialog.showMaskFun();
          that.processMsg = r.msg
          return;
        }
        that.$parent.returnCode(r, function () {
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
        });
      })
    },
    getImage() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.detail.url
      console.log(link.href)
      // link.target = '_blank'
      link.setAttribute('download', '文件名称')
      document.body.appendChild(link)
      link.click()
      window.open(this.detail.url, '_blank')

    },
    closeTmgDialog() {
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    closeProcessDialog() {
      this.processMsg = ""
      this.$refs.processDialog.closeMask();
    },
    goPurchaseChances() {
      this.$router.push({path: '/purchaseChances'})
    },
    // 辅助方法：计算 base64 图片大小
    base64Size(base64) {
      let str = base64.split(',')[1]; // 去掉前缀 data:image/jpeg;base64,
      let eqIndex = str.indexOf('=');
      if (eqIndex > 0) {
        str = str.substring(0, eqIndex); // 去掉填充字符
      }
      let length = str.length;
      return length * 3 / 4; // 得到字节数
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/aiDressUp.vue